import React from 'react';
import AsyncPage from './async';
import DefaultBusinessLayout from '../../../../components/layout/DefaultBusinessLayout';

export default [
  <DefaultBusinessLayout
    key="/business/technologies/agile-hand-tracking"
    exact
    path="/business/technologies/agile-hand-tracking"
    component={AsyncPage}
  />,
];
